import React from 'react';
import cx from 'classnames';
import { getThemeClassNames } from 'themes';

import { AppDomain } from 'types/enums/AppDomain';

import css from './badge.module.sass';

interface Props {
  className?: string;
}

export const Badge: React.FC<Props> = ({ className, children }) => {
  const rootClassName = getThemeClassNames(css.root, {
    [AppDomain.LocalsDate]: css.rootTypeLocalsDate,
    [AppDomain.LustStation]: css.rootTypeLocalsDate,
    [AppDomain.JustLovebirds]: css.rootJustLovebirds,
    [AppDomain.AdventureDate]: css.rootJustLovebirds,
  });

  return <span className={cx(rootClassName, className)}>{children}</span>;
};
